import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Американски футбол",
    Baseball: "Бейзбол",
    Basketball: "Баскетбол",
    Boxing: "Бокс",
    Chess: "Шах",
    Cricket: "Крикет",
    Darts: "Дартс",
    Entertainment: "Забавление",
    "E-Sports": "Е-Спортове",
    Football: "Футбол",
    "Formula 1": "Формула 1",
    "Gaelic Football": "Галски Футбол",
    "Generic Sport": "Генеричен спорт",
    Golf: "Голф",
    "Greyhound Racing": "Кучешки надбягвания",
    Handball: "Хандбал",
    "Ice Hockey": "Хокей на лед",
    IndyCar: "Индикар",
    MMA: "ММА",
    Nascar: "Наскар",
    Politics: "Политика",
    "Rugby League": "Ръгби Лига",
    "Rugby Union": "Ръгби Юниън",
    Snooker: "Снукър",
    "Table Tennis": "Тенис на маса",
    Tennis: "Тенис",
    "Virtual Football": "Виртулен футбол",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} да спечели",
    WinFirstRound: "{name} да спечели първия рунд",
    FirstTouchdown: "{name} да отбележат първо тъчдаун",
    FirstTry: "{name} да отбележат първо Трай",
    TotalGoals: "{name} Брой голове",
    TotalRuns: "{name} Общо бягания",
    TotalPoints: "{name} Брой точки",
    TopBatsman: "{name} да бъде Топ Батсман",
    TopBowler: "{name} да бъде Топ Боулър",
    FirstScore: "{name} да отбележи първи"
  },
  PromoTexts: {
    Pick: "Направете своя избор",
    Bet: "заложете",
    Pays: "заплащане"
  },
  DateTimeTexts: {
    Today: "Днес",
    Tomorrow: "Утре",
    Live: "на Живо"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Направете своя избор",
    Return: "заплащане",
    Stake: "заложете",
    Draw: "X"
  },
  H2HTexts: {
    goals_scored: "Отбелязане голове",
    shots: "Удари",
    shots_on_target: "Удари в очертанията",
    ball_possession: "Владение на топката",
    goals_conceded: "Допуснати голове",
    "Per match": "за мач",
    H2H: "TaT",
    W: "П",
    D: "Р",
    L: "З",
    T: "Р",
    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing Stats",
    rushing_yards_per_game: "Rushing Yards",
    rushing_touchdowns: "Rushing Touchdowns (total)",
    rushing_percentage: "Rushing %",
    passing_stats: "Passing Stats",
    passing_yards_per_game: "Passing Yards",
    passing_touchdowns: "Passing Touchdowns (total)",
    passing_percentage: "Passing %"
  }
};
